// Invoice data model for the SaaS billing prototype.
// See plans/saas-billing/01-stripe-billing-foundation.md for canonical types.

import { CurrencyCode } from './subscription.model';

export interface Invoice {
  id: string;                          // Stripe Invoice id
  number: string;                      // Stripe-assigned invoice number ("INV-2026-0042")
  status: 'paid' | 'open' | 'void' | 'uncollectible' | 'draft';
  issuedAt: string;
  paidAt: string | null;
  periodStart: string;
  periodEnd: string;
  currency: CurrencyCode;
  subtotalMinor: number;
  discountMinor: number;
  taxMinor: number;
  taxRate: number | null;              // % rate active at issue time. Null for tax-free or unknown.
  taxBasis: 'inclusive' | 'exclusive' | null;  // Display pattern; see #10 for per-country rules.
  totalMinor: number;
  hostedInvoiceUrl: string;            // Stripe-hosted page (used by Portal links)
  invoicePdfUrl: string;               // Stripe-hosted PDF
  lineItems: InvoiceLine[];
}

export type InvoiceLineKind =
  | 'subscription'    // Plan * seats recurring charge
  | 'topup'           // One-time AI credit top-up
  | 'proration'       // Mid-cycle change credit or debit (can be negative)
  | 'discount'        // Coupon applied as a separate line (rare; usually folded into discountMinor)
  | 'tax';            // Tax line (only when invoice presents tax as its own line)

export interface InvoiceLine {
  description: string;                 // "Professional plan * 8 seats"
  kind: InvoiceLineKind;
  quantity: number;
  unitAmountMinor: number;
  amountMinor: number;                 // Can be negative for proration credits
  periodStart: string;
  periodEnd: string;
}
